import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './css/destyle.css';
import './css/iconfonts.css';
import './css/style.css';
import './css/style-blue.css';
import './css/style-brown.css';
import './css/style-gray.css';
import './css/style-green.css';
import './css/style-pink.css';
import './css/style-sky.css';
import './css/style-yellow.css';
import { Layout } from './views/layouts/Layout';

ReactDOM.render(
  <React.StrictMode>
    <Layout/>
  </React.StrictMode>,
  document.getElementById('root')
);